















































import { Component, Prop, Vue } from 'vue-property-decorator';
import NavBar from '@/components/NavBar.vue';
import TabBar from '@/components/TabBar.vue';
import Button from '@/components/Button.vue';
import { namespace } from 'vuex-class';
import Loader from '@/components/Loader.vue';
import TextField from '@/components/form/TextField.vue';
import { ValidationError } from 'class-validator';
import { Validator } from 'class-validator';
import NewTranslation from '@/components/i18n/NewTranslation.vue';
import i18next from 'i18next';

const AuthModule = namespace('auth');

@Component({
  components: {
    NewTranslation,
    NavBar,
    TabBar,
    Button,
    Loader,
    TextField,
  },
})
export default class RequestPasswordResetView extends Vue {
  @Prop(Object)
  private pagedata!: any;

  @Prop(Array)
  private lang!: Array<{ [key: string]: string }>;

  @AuthModule.Action('requestResetPassword')
  public requestResetPassword!: any;

  public resetIsLoading: boolean = false;

  public errors: ValidationError[] = [];

  public email: string = '';

  public cellphoneNumber: string = '';

  public getFieldError(fieldName: string): ValidationError | null {
    const error = this.errors.find(e => e.property === fieldName);
    return error || null;
  }

  public removeFieldError(fieldName: string): void {
    let index = 0;
    this.errors.forEach((err, i) => {
      if (err.property === fieldName) {
        index = i;
      }
    });
    this.errors.splice(index, 1);
  }

  public validate(): boolean {
    this.errors = [];
    const validator = new Validator();

    if (validator.isNotEmpty(this.email) && validator.isNotEmpty(this.cellphoneNumber)) {
      this.addError('email', 'isNotEmpty', i18next.t('requestPasswordReset.validation.email.isNotEmpty'));
      this.addError(
        'cellphoneNumber',
        'isNotEmpty',
        i18next.t('requestPasswordReset.validation.cellphoneNumber.isNotEmpty')
      );
    }

    if (validator.isEmpty(this.email) && validator.isEmpty(this.cellphoneNumber)) {
      this.addError('email', 'isEmpty', i18next.t('requestPasswordReset.validation.email.isEmpty'));
      this.addError('cellphoneNumber', 'isEmpty', i18next.t('requestPasswordReset.validation.cellphoneNumber.isEmpty'));
    }

    if (this.email && !validator.isEmail(this.email)) {
      this.addError('email', 'isEmail', i18next.t('requestPasswordReset.validation.email.isEmail'));
    }

    if (this.cellphoneNumber) {
      if (!validator.isNumberString(this.cellphoneNumber)) {
        this.addError(
          'cellphoneNumber',
          'isNumberString',
          i18next.t('requestPasswordReset.validation.cellphoneNumber.isNumberString')
        );
      } else if (this.cellphoneNumber[0] !== '0' && this.cellphoneNumber[0] !== '+') {
        this.addError(
          'cellphoneNumber',
          'notStartingWithZeroOrPlus',
          i18next.t('requestPasswordReset.validation.cellphoneNumber.notStartingWithZeroOrPlus')
        );
      }
    }

    return this.errors.length === 0;
  }

  public addError(property: string, constraintType: string, message: string): void {
    const errorExisting = this.errors.find(err => err.property === property);
    if (errorExisting) {
      errorExisting.constraints[constraintType] = message;
    } else {
      this.errors.push({
        property,
        constraints: { [constraintType]: message },
        children: [],
      });
    }
  }

  public async submit(): Promise<void> {
    this.email = this.email.toLowerCase();

    if (!this.validate()) {
      return;
    }

    this.resetIsLoading = true;

    try {
      await this.requestResetPassword({ email: this.email, cellphoneNumber: this.cellphoneNumber });
      await this.$router.push({ name: 'passwordReset' });
    } catch (e) {
      console.log('Failed to request user password reset', e);

      if (e && e.response && e.response.status === 422) {
        this.errors = e.response.data;
        this.showError(
          i18next.t('requestPasswordReset.requestError.dialog.validation.title'),
          i18next.t('requestPasswordReset.requestError.dialog.validation.body')
        );
      } else {
        this.showError(
          i18next.t('requestPasswordReset.requestError.dialog.unknown.title'),
          i18next.t('requestPasswordReset.requestError.dialog.unknown.body')
        );
      }
    } finally {
      this.resetIsLoading = false;
    }
  }

  public showError(title: string, message: string): void {
    this.$store.commit('openOverlay', {
      overlayName: 'Info',
      overlayData: {
        title,
        message,
      },
    });
  }
}
